import "vuetify/styles";
import "@mdi/font/css/materialdesignicons.css";

import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

const vuetify = createVuetify({
  components: { ...components, VTooltip: null, VMenu: null },
  directives,
  icons: {
    defaultSet: "mdi",
  },
  display: {
    mobileBreakpoint: 'sm',
    thresholds: {
      xs: 340,
      sm: 640,
      md: 768,
      lg: 1280,
      xl: 1440,
      xxl: 1600,
    },
  },
  theme: {
    themes: {
      light: {
        colors: {
          primary: "#FF7A00",
        },
      },
    },
  },
});

export default vuetify;
